import React from 'react';
import '../../../styles/establishment/establishmentHeader.css';

const CaseDataDashboardHeading = () => {
  return (
  <div>
    <div id="establishment-dashboard-header">
      <div
        id="establishment-dashboard-instructions-container"
        className="alert alert-info col-xs-12 non-mobile">
        <div id="establishment-dashboard-instructions">
          <div className="first-line">Instructions</div>
          <p>
            Select the 'Add 300/301 Data' button below to add case data for an establishment.
            To edit existing data, select 'Edit' next to the case number.
          </p>
          <p>
            Review the Instructions for Finalizing and Submitting your data to OSHA.
          </p>
        </div>
      </div>
    </div>
  </div>
  );
};

export default CaseDataDashboardHeading;



/** WEBPACK FOOTER **
 ** ./src/components/caseData/CaseDataManagement/CaseDataDashboardHeading.js
 **/